module.exports = __webpack_public_path__ + "components/resort-webcams/static/icon--panorama-04e07d933400f960e1a51e2b85164a77.svg";